module.exports = __webpack_public_path__ + "media/images/front/banner_cc_square-70e9b14f9419cce82a1cf43ef6e8acad.jpg";